import { Modal } from 'ui';

import { ChangeGoalForm } from '../../../molecules';
import { EditPeerPageModalFooter } from './EditPeerPageModalFooter';
import {
  ModalTitleWithBackButton,
  useEditPeerPageModalProvider,
} from './EditPeerPageModalProvider';

const EditParticipantGoalModal = () => {
  const { opened, close, meta } = useEditPeerPageModalProvider({
    id: 'goal',
  });

  const isParticipant = meta.peer.__type === 'participants';

  const goalType =
    isParticipant && meta.campaign.__type === 'athon'
      ? meta.campaign.participant_options.goal_type
      : 'currency';

  const units =
    isParticipant && meta.campaign.__type === 'athon'
      ? meta.campaign.units_of_activity_plural
      : undefined;

  const modalTitle =
    isParticipant && meta.campaign.__type === 'athon' && goalType === 'units'
      ? `${meta.campaign.units_of_activity_singular} Goal`
      : 'Fundraising Goal';

  return (
    <Modal
      opened={opened}
      onClose={close}
      title={<ModalTitleWithBackButton tt="capitalize">{modalTitle}</ModalTitleWithBackButton>}
    >
      <ChangeGoalForm initialValue={meta.peer.goal} goalType={goalType} units={units} />
      <EditPeerPageModalFooter />
    </Modal>
  );
};
export { EditParticipantGoalModal };
